document.addEventListener('DOMContentLoaded', function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    // No animation: the row stays a plain, manually scrollable list with
    // each product shown exactly once.
    return;
  }

  var rows = document.querySelectorAll('[data-autoscroll]');

  // Appends one copy of every original card to the end of the row and
  // returns the first card of that copy. The copies are hidden from screen
  // readers and keyboard focus: they only exist to make the loop endless.
  function appendCopy(row, originals, markFirst) {
    var firstClone = null;

    originals.forEach(function (card, index) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.setAttribute('data-clone', 'true');

      if (markFirst && index === 0) {
        clone.setAttribute('data-dup', 'true');
        firstClone = clone;
      }

      row.appendChild(clone);
    });

    return firstClone;
  }

  function setupRow(row) {
    var originals = Array.prototype.slice.call(row.children);
    if (originals.length === 0) {
      return;
    }

    // Three copies in total (the original plus two clones), the same layout
    // the loop logic below was always built for.
    var firstDupCard = appendCopy(row, originals, true);
    appendCopy(row, originals, false);

    var isPremium = row.closest('.product-row--premium') !== null;
    var direction = isPremium ? -1 : 1;
    var speed = 0.6;
    var isPaused = false;
    var resumeTimer = null;
    var isResetting = false;
    var started = false;
    // Recalculated on every resize/reflow instead of once at startup, so a
    // layout change (a lazy-loaded image finishing after the row is already
    // on screen, a font swap, a resize) can never leave this pointing at a
    // stale position.
    var resetPoint = null;

    function measureResetPoint() {
      var rowRect = row.getBoundingClientRect();
      var dupRect = firstDupCard.getBoundingClientRect();
      return dupRect.left - rowRect.left + row.scrollLeft;
    }

    function recalculate() {
      resetPoint = measureResetPoint();

      if (!started && row.scrollWidth > row.clientWidth) {
        started = true;
        row.scrollLeft = isPremium ? resetPoint : 0;
        // scrollLeft just moved, so the reset point (measured relative to
        // scrollLeft) needs one more pass to match the new position.
        resetPoint = measureResetPoint();
      }
    }

    function step() {
      if (started && !isPaused && !isResetting && resetPoint !== null) {
        var next = row.scrollLeft + direction * speed;
        var willJump = direction === 1 ? next >= resetPoint : next <= 0;

        if (willJump) {
          isResetting = true;
          var target = direction === 1 ? next - resetPoint : next + resetPoint;
          row.scrollTo({ left: target, behavior: 'smooth' });
          setTimeout(function () {
            isResetting = false;
          }, 600);
        } else {
          row.scrollLeft = next;
        }
      }
      requestAnimationFrame(step);
    }

    function pauseWithResume() {
      isPaused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { isPaused = false; }, 2000);
    }

    row.addEventListener('mouseenter', function () { isPaused = true; clearTimeout(resumeTimer); });
    row.addEventListener('mouseleave', function () { isPaused = false; });
    row.addEventListener('touchstart', function () { isPaused = true; clearTimeout(resumeTimer); }, { passive: true });
    row.addEventListener('touchend', pauseWithResume);
    row.addEventListener('wheel', pauseWithResume, { passive: true });

    // Covers every real cause of the row's width changing: window resize,
    // font swap, or any image inside it finishing loading and changing the
    // row's intrinsic size. ResizeObserver fires once immediately on
    // observe(), so this also replaces the old "wait for fonts, guess twice"
    // startup check with something that keeps correcting itself for as long
    // as the page is open, instead of checking once and giving up.
    var resizeObserver = new ResizeObserver(recalculate);
    resizeObserver.observe(row);

    row.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', recalculate, { once: true });
      }
    });

    requestAnimationFrame(step);
  }

  rows.forEach(setupRow);
});
